var React = require('react');

function ArrowAnt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 25L13 12.0247L0 0V7.5808V10.6226V13.4743H2.85192V6.51141L8.86472 12.096L0 20.9601V25Z","fill":"#4285F4"}));
}

ArrowAnt.defaultProps = {"width":"13","height":"25","viewBox":"0 0 13 25","fill":"none"};

module.exports = ArrowAnt;

ArrowAnt.default = ArrowAnt;
